var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.88 44.93"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".9_svg__cls-1,.9_svg__cls-2{fill:none;stroke-miterlimit:10;stroke-width:2px}.9_svg__cls-1{stroke:#231815}.9_svg__cls-2{stroke:#00b468}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9_svg__\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9_svg__\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "9_svg__cls-1",
    d: "M28.45 40.15v3.78H1V16.48h27.45v4.04M5.17 1h19.11v15.48H5.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "9_svg__cls-2",
    d: "M10.9 7.17h1.69v1.37H10.9zM16.86 7.17h1.69v1.37h-1.69z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "9_svg__cls-1",
    cx: 29.19,
    cy: 30.21,
    r: 9.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "9_svg__cls-2",
    d: "M23.72 30.89l3.73 3.73 7.2-7.19"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOS44OCA0NC45MyI+PGRlZnM+PHN0eWxlPi5jbHMtMSwuY2xzLTJ7ZmlsbDpub25lO3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDoycHg7fS5jbHMtMXtzdHJva2U6IzIzMTgxNTt9LmNscy0ye3N0cm9rZTojMDBiNDY4O308L3N0eWxlPjwvZGVmcz48dGl0bGU+OTwvdGl0bGU+PGcgaWQ9IuWbvuWxgl8yIiBkYXRhLW5hbWU9IuWbvuWxgiAyIj48ZyBpZD0i5Zu+5bGCXzEtMiIgZGF0YS1uYW1lPSLlm77lsYIgMSI+PHBvbHlsaW5lIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIyOC40NSA0MC4xNSAyOC40NSA0My45MyAxIDQzLjkzIDEgMTYuNDggMjguNDUgMTYuNDggMjguNDUgMjAuNTIiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjUuMTciIHk9IjEiIHdpZHRoPSIxOS4xMSIgaGVpZ2h0PSIxNS40OCIvPjxyZWN0IGNsYXNzPSJjbHMtMiIgeD0iMTAuOSIgeT0iNy4xNyIgd2lkdGg9IjEuNjkiIGhlaWdodD0iMS4zNyIvPjxyZWN0IGNsYXNzPSJjbHMtMiIgeD0iMTYuODYiIHk9IjcuMTciIHdpZHRoPSIxLjY5IiBoZWlnaHQ9IjEuMzciLz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjI5LjE5IiBjeT0iMzAuMjEiIHI9IjkuNjkiLz48cG9seWxpbmUgY2xhc3M9ImNscy0yIiBwb2ludHM9IjIzLjcyIDMwLjg5IDI3LjQ1IDM0LjYyIDM0LjY1IDI3LjQzIi8+PC9nPjwvZz48L3N2Zz4=";
export { Svg9 as ReactComponent };